import React, { useContext, useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { useNavigate } from "react-router";
//
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import useLocaleRoute from "../../../../../../common/hooks/useLocaleRoute";
import useModulePublic from "../../../../../hooks/useModulePublic";
import IconPopup from "../../../../../../common/components/popup/IconPopup";
import { StoreContext } from "../../../../../../store/StoreProvider";
import CommonList from "../../common/CommonList";
import CommonListItem from "../../common/CommonListItem";
import PopupEdit from "../../common/PopupEdit";
import PopupListItem from "../../common/PopupListItem";
import PopupChoose from "../../common/PopupChoose";
//
import Act from "../../../../../../store/actions";
import { MODULE_ID } from "../../../../../../config/CONSTANTS";
import urls from "../../../../../../api/project/ApiUrls";
//
import fireDb from "../../../../../../api/firebase/realtime/utils";
import { isElectronApp } from "../../../../../../common/utils/electronAppHelper";
import { deleteUserFile } from "../../../../service/datasetService";
import role from "../../../../../../config/App-role";

const popupMenuPosition = {
  anchorOrigin: {
    vertical: "bottom",
    horizontal: "left",
  },
  transformOrigin: {
    vertical: "top",
    horizontal: "left",
  },
};

const StyledList = CommonList;

const AccordionDetailChildren = () => {
  // props

  // route,intl
  const intl = useIntl();
  const navigate = useNavigate();
  // store
  const [state, dispatch] = useContext(StoreContext);
  const { user, sna } = state;
  const { locale, group, groups } = user;
  const { dataset } = sna;
  // local state
  const [listItems, setListItems] = useState(dataset.personal || []);
  const [listItemFocus, setListItemFocus] = useState(null);
  const [popupPageIdx, setPopupPageIdx] = useState(0);
  const [popPageCtx, setPopPageCtx] = useState({});
  const [popChooseOptions, setPopChooseOptions] = useState([]);
  const [popEditInput, setPopEditInput] = useState("");
  const [editSubmitFlag, setEditSubmitFlag] = useState(false);
  // hooks
  const { handleLocaleRoute } = useLocaleRoute(
    locale,
    urls?.locale_lang?.LOCALE_DEFAULT
  );
  const { handlePublic } = useModulePublic();

  const disabledEditFile = !handlePublic(
    MODULE_ID.snaSidebarFilePersonalDatasetShare,
    false
  );

  useEffect(() => {
    if (Array.isArray(dataset.personal)) {
      setListItems(dataset.personal);
    }
  }, [dataset.personal]);

  useEffect(() => {
    const getCheckedVal = (_group) => {
      if (!(listItemFocus && _group?.uid)) return false;
      return !!listItemFocus?.groupowner?.[_group.uid];
    };
    const groupOptions = Object.values(groups || {})
      .map((_groupObj) => ({
        ..._groupObj,
        id: _groupObj.uid,
        label: _groupObj.displayName,
        checked: getCheckedVal(_groupObj),
      }))
      .filter((item) => !item.checked)
      // 若是 group editor 以上的權限,才可以分享給該 group
      .filter((item) =>
        [role.root, role.admin, role.developer, role.editor].includes(item.role)
      );

    setPopChooseOptions(groupOptions);
  }, [groups, listItemFocus]);

  const handleListItemCheckChange = (e, listItem) => {
    const { checked } = e.target;
    const newItems = [];
    listItems.forEach((item) => {
      if (item.id === listItem.id) {
        newItems.push({
          ...item,
          checked,
        });
      } else {
        newItems.push(item);
      }
    });
    setListItems(newItems);
    dispatch({
      type: Act.SNA_CUR_DATASET,
      payload: {
        ...dataset,
        personal: [...newItems], // 儲存到 group
      },
    });
  };

  const refreshDataset = () => {
    // 因為 personal 及 group 可能共有 dataset, 所以一併搜尋
    // 重新搜尋 personal dataset
    dispatch({
      type: Act.SNA_REFRESH_PERSONAL_DATASET,
      payload: true,
    });
    // 重新搜尋 group dataset
    dispatch({
      type: Act.SNA_REFRESH_GROUP_DATASET,
      payload: true,
    });
  };

  const handleDeleteListItem = (listItem) => () => {
    // 儲存至 firebase, 儲存成功的話重新抓取 dataset 資料
    const onDeleteSuccess = () => {
      dispatch({
        type: Act.COMMON_SET_SUCCESS_MESSAGE,
        payload: {
          open: true,
          content: intl.formatMessage({
            id: "sna.sidebar.filetool.personal.delete.file.success",
            defaultMessage: "已刪除檔案",
          }),
        },
      });
      // 因為 personal 及 group 可能共有 dataset, 所以一併搜尋
      refreshDataset();
    };
    const onDeleteError = (error) => {
      dispatch({
        type: Act.COMMON_SET_ERROR_MESSAGE,
        payload: {
          open: true,
          content: error.message,
        },
      });
    };

    dispatch({
      type: Act.SNA_DIALOG_CONTEXT,
      payload: {
        openSignal: true,
        title: intl.formatMessage({
          id: "sna.sidebar.filetool.personal.delete.file.modal.title",
          defaultMessage: "確定要刪除資料集嗎？",
        }),
        contentText: intl.formatMessage({
          id: "sna.sidebar.filetool.personal.delete.file.modal.text",
          defaultMessage: "刪除後將無法復原此資料集。",
        }),
        onYes: () =>
          deleteUserFile(
            listItem?.uid,
            user?.uid,
            onDeleteSuccess,
            onDeleteError
          ),
        yesText: intl.formatMessage({
          id: "sna.sidebar.filetool.personal.delete.file.modal.confirm",
          defaultMessage: "刪除",
        }),
        noText: intl.formatMessage({
          id: "sna.sidebar.filetool.personal.delete.file.modal.cancel",
          defaultMessage: "取消",
        }),
      },
    });
  };

  const handleShareSubmit = (e, optionsChecked) => {
    const updatedFileGroupsData = optionsChecked
      .filter((opt) => opt.checked)
      .reduce((acc, cur) => {
        if (cur?.uid) {
          acc[cur.uid] = true;
        }
        return acc;
      }, {});
    const onSuccess = () => {
      const onUpdateGroupFileSuccess = () => {
        dispatch({
          type: Act.COMMON_SET_SUCCESS_MESSAGE,
          payload: {
            open: true,
            content: "已分享至團隊",
          },
        });
        // 因為 personal 及 group 可能共有 dataset, 所以一併搜尋
        refreshDataset();
      };
      const onUpdateGroupFileError = (err) => {
        dispatch({
          type: Act.COMMON_SET_ERROR_MESSAGE,
          payload: {
            open: true,
            content: err.message,
          },
        });
      };
      optionsChecked
        .filter((opt) => opt.checked)
        .forEach((opt) => {
          fireDb.updateGroupFilesMulti({
            groupId: opt.uid,
            data: {
              [listItemFocus.uid]: {
                isOwner: true,
                uid: listItemFocus.uid,
              },
            },
            onSuccess: onUpdateGroupFileSuccess,
            onError: onUpdateGroupFileError,
          });
        });
    };
    const onError = (err) => {
      dispatch({
        type: Act.COMMON_SET_ERROR_MESSAGE,
        payload: {
          open: true,
          content: err.message,
        },
      });
    };
    fireDb.updateFileGroup({
      fileUid: listItemFocus.uid,
      data: updatedFileGroupsData,
      onSuccess,
      onError,
    });
  };

  const handleEditInputChange = (e) => {
    setPopEditInput(e.target.value);
  };

  const handleClosePopup = () => {
    setPopupPageIdx(0);
    setEditSubmitFlag(true);
  };

  const handleEditSubmit = () => {
    if (isElectronApp()) {
      // local 不允許重新命名
    } else {
      // 儲存至 firebase
      const onSuccess = () => {
        dispatch({
          type: Act.COMMON_SET_SUCCESS_MESSAGE,
          payload: {
            open: true,
            content: intl.formatMessage({
              id: "sna.sidebar.filetool.personal.edit.file.success",
              defaultMessage: "檔案已重新命名",
            }),
          },
        });
        // 因為 personal 及 group 可能共有 dataset, 所以一併搜尋
        refreshDataset();
      };
      const onError = (error) => {
        dispatch({
          type: Act.COMMON_SET_ERROR_MESSAGE,
          payload: {
            open: true,
            content: error.message,
          },
        });
      };
      const newData = {
        displayName: popEditInput,
      };
      fireDb.updateFileDisplayName({
        fileUid: listItemFocus?.uid,
        data: newData,
        onSuccess,
        onError,
      });
      handleClosePopup();
    }
  };

  const getPopupPageShare = () =>
    (popChooseOptions.length > 0 && {
      children: (
        <PopupListItem
          text={intl.formatMessage({
            id: "sna.sidebar.filetool.share.to.group",
            defaultMessage: "分享至團隊",
          })}
          onClick={() => setPopupPageIdx(1)}
          withNextStep
        />
      ),
    }) || {
      children: (
        <PopupListItem
          text={intl.formatMessage({
            id: "sna.sidebar.filetool.share.to.group",
            defaultMessage: "分享至團隊",
          })}
          disabled
          withNextStep={false}
        />
      ),
    };

  const getPopupPageEdit = () => ({
    children: (
      <PopupListItem
        text={intl.formatMessage({
          id: "sna.sidebar.filetool.rename.file",
          defaultMessage: "重新命名",
        })}
        onClick={() => setPopupPageIdx(2)}
        withNextStep
      />
    ),
  });

  const getPopupPageDelete = () =>
    // todo: 不能刪除預設資料集
    ({
      children: (
        <PopupListItem
          text={intl.formatMessage({
            id: "sna.sidebar.filetool.delete.file",
            defaultMessage: "刪除資料集",
          })}
          onClick={handleDeleteListItem(listItemFocus)}
          withNextStep={false}
        />
      ),
    });

  const popupPage0 = {
    body: [
      getPopupPageShare(),
      getPopupPageEdit(),
      getPopupPageDelete(),
    ].filter((item) => !!item),
  };
  const disabledShareSubmitBtn = (options) => true;

  // 挑選要分享的團隊
  const popupPage1 = {
    // body: popup 主體
    body: (
      <PopupChoose
        options={popChooseOptions.map((opt) => ({
          ...opt,
          id: opt?.uid,
        }))}
        onSubmit={handleShareSubmit}
        submitText={intl.formatMessage({
          id: "sna.sidebar.filetool.share.confirm",
          defaultMessage: "分享",
        })}
        disabledBtn={disabledShareSubmitBtn}
      />
    ),
    // footer
    footer: null,
  };

  const disabledEditSubmitBtn = !popEditInput;
  // 變更檔案名稱
  const popupPage2 = {
    // body: popup 主體
    body: (
      <PopupEdit
        context={listItemFocus}
        title={intl.formatMessage({
          id: "sna.sidebar.filetool.edit.filename",
          defaultMessage: "重新命名",
        })}
        inputLabel={intl.formatMessage({
          id: "sna.sidebar.filetool.edit.filename.label",
          defaultMessage: "資料集名稱",
        })}
        onInputChange={handleEditInputChange}
        onSubmit={() => handleEditSubmit()}
        submitText={intl.formatMessage({
          id: "sna.sidebar.filetool.edit.filename.confirm",
          defaultMessage: "確認",
        })}
        disabledBtn={disabledEditSubmitBtn}
      />
    ),
    // footer
    footer: null,
  };

  const popupPages = [popupPage0, popupPage1, popupPage2];

  // 當選擇的 group 變更 or pageIdx 便更時, 重新產生 popup 內容
  useEffect(() => {
    setPopPageCtx(popupPages[popupPageIdx]);
  }, [popupPageIdx, popEditInput, listItemFocus, popChooseOptions]);

  const getIconButtonProps = (uGroup) => ({
    onButtonIconClick: () => {
      setListItemFocus(uGroup);
    },
    sx: {
      color: "#fff",
    },
    disabled: disabledEditFile,
  });

  const getMenuProps = () => ({
    ...popPageCtx,
    ...popupMenuPosition,
    onClose: () => setPopupPageIdx(0),
  });

  return (
    <StyledList>
      {listItems.map((uFile, idx) => (
        <CommonListItem
          key={idx.toString()}
          withCheckbox
          withAvatar={false}
          checked={uFile.checked}
          onCheckboxChange={handleListItemCheckChange}
          context={{
            id: uFile?.uid,
            textPrimary: uFile.displayName,
          }}
          avatarSize="normal"
          secondaryAction={
            <IconPopup
              icon={<MoreHorizIcon />}
              iconButtonProps={{
                ...getIconButtonProps(uFile),
              }}
              menuProps={{
                ...getMenuProps(),
              }}
              editSubmitFlag={editSubmitFlag}
              setEditSubmitFlag={setEditSubmitFlag}
            />
          }
          darkMode
        />
      ))}
    </StyledList>
  );
};

export default AccordionDetailChildren;
